export enum ECoworkerView {
  List = "list",
  Map = "map",
}
